const store = {
  namespaced: true,
  state() {
    return {
      isAuth: false,
      insertedPhoneNumber: "",
      userData: null,
      specificUserData: null,

      loginStatusCode: null,
    };
  },
  getters: {
    isAuth: (state) => state.isAuth,
    insertedPhoneNumber: (state) => state.insertedPhoneNumber,
    userData: (state) => state.userData,
    specificUserData: (state) => state.specificUserData,

    loginStatusCode: (state) => state.loginStatusCode,
  },
  mutations: {
    SET_INSERTED_PHONE_NUMBER: (state, str) =>
      (state.insertedPhoneNumber = str),
    SET_IS_AUTH: (state, flag) => (state.isAuth = flag),
    SET_USER_DATA: (state, data) => (state.userData = data),
    SET_SPECIFIC_USER_DATA: (state, data) => (state.specificUserData = data),

    SET_LOGIN_STATUS_CODE: (state, code) => (state.loginStatusCode = code),
  },
  actions: {
    setInsertedPhoneNumber: ({ commit }, str) =>
      commit("SET_INSERTED_PHONE_NUMBER", str),
    setLoginStatusCode: ({ commit }, code) =>
      commit("SET_LOGIN_STATUS_CODE", code),
    setAuthData: async function ({ commit }, data) {
      this.$cookies.set("token", data.access);
      this.$cookies.set("refreshToken", data.refresh);
      this.$axios.setHeader("Authorization", `Bearer ${data.access}`);

      await this.dispatch("user/fetchUserData");
      // this 2 things are needed for header
      await this.dispatch("favorites/fetchFavoritesAdverts");
      await this.dispatch("announcements/fetchMyAnnouncements", {
        type: "all",
        requireAll: true,
      });

      commit("SET_IS_AUTH", true);
    },
    register: async function ({ commit }, data) {
      const res = await this.$axios({
        method: "post",
        url: `/api/register/`,
        data: {
          phone: data.phone.replace(/\s/g, ""),
        },
      });
    },
    resetPassword: async function ({ commit }, data) {
      const res = await this.$axios({
        method: "patch",
        url: `/api/register/${data.phone.replace(/\s/g, "")}/`,
      });
    },
    loginGoogle: async function ({ commit }, data) {
      try {
        const res = await this.$axios({
          method: "post",
          url: `/api/google-login/`,
          data: { access_token: data.access_token },
        });
        const { access, refresh } = res.data;
        await this.dispatch("user/setAuthData", {
          access,
          refresh,
        });
        this.$router.push({ path: this.localePath("/") });
      } catch (error) {
        this.$router.push({ path: this.localePath("/registration") });
      }
    },
    login: async function ({ commit }, data) {
      try {
        const res = await this.$axios({
          method: "post",
          url: `/api/token/`,
          data: {
            username: data.phone.replace(/\s/g, ""),
            password: data.password.replace(/\s/g, ""),
          },
        });
        const { access, refresh } = res.data;
        await this.dispatch("user/setAuthData", {
          access,
          refresh,
        });
        this.$router.push({ path: this.localePath("/") });
      } catch (error) {
        commit("SET_LOGIN_STATUS_CODE", error.response.status);
      }
    },
    logout: async function ({ commit }, data) {
      try {
        this.$cookies.remove("token");
        this.$cookies.remove("refreshToken");
        this.$axios.setHeader("Authorization", null);
        commit("SET_IS_AUTH", false);
        commit("SET_USER_DATA", null);
        // no need redirection
        // this.$router.push({ path: this.localePath("/login") });
      } catch (error) {
        console.dir(error);
      }
    },
    fetchUserData: async function ({ commit }, data) {
      try {
        const res = await this.$axios({
          method: "get",
          url: `/api/users/me`,
        });
        commit("SET_USER_DATA", res.data);
      } catch (error) {
        console.dir(error);
      }
    },
    fetchUserDataById: async function ({ commit }, userId) {
      try {
        const res = await this.$axios({
          method: "get",
          url: `/api/users/${userId}/`,
        });
        commit("SET_SPECIFIC_USER_DATA", res.data);
      } catch (error) {
        console.dir(error);
      }
    },
  },
};

export default store;
